export const LEVELS = {
  EMPLOYEE: "EMPLOYEE",
  ADMIN: "ADMIN",
  SUPERADMIN: "SUPERADMIN",
}
